import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";
import type { Candidate, EvaluationRound } from "@/types/database";

interface AssessmentCompletionGuardProps {
  children: React.ReactNode;
  candidate: Candidate | null;
  existingEvaluations: EvaluationRound[];
}

export const AssessmentCompletionGuard = React.memo(
  ({
    children,
    candidate,
    existingEvaluations,
  }: AssessmentCompletionGuardProps) => {
    if (!candidate) return <>{children}</>;

    const hasCompletedAssessment =
      candidate.status === "assessment_completed" ||
      candidate.assesment_submitted_at;
    // existingEvaluations.some(
    //   (evaluation) =>
    //     evaluation.round_name === "mcq" ||
    //     evaluation.round_name === "open_ended"
    // );

    if (hasCompletedAssessment) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <Card className="w-full max-w-md">
            <CardContent className="pt-6">
              <div className="text-center space-y-4">
                <CheckCircle className="h-12 w-12 text-green-500 mx-auto" />
                <h3 className="text-lg font-semibold text-green-600">
                  Assessment Completed
                </h3>
                <p className="text-gray-600">
                  Your assessment is completed or your time has ended. Thank you
                  for taking part!
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }

    return <>{children}</>;
  }
);

AssessmentCompletionGuard.displayName = "AssessmentCompletionGuard";
